import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../context/AuthContext";

const TruncateTest = ({ description, onAuth }) => {
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight,
      );
    }
  }, [description]);

  const onClickshowMoreProducts = () => {
    if (!isAuthenticated) {
      onAuth && onAuth();
    } else {
      setShowMore(!showMore);
    }
  };

  return (
    <>
      {!!description && (
        <div className={`tw-text-sm tw-mt-2`}>
          <div ref={textRef} className={showMore ? "" : "truncate-text"}>
            {description}
          </div>
          {isOverflowing && (
            <div
              className={`tw-flex tw-justify-end tw-text-theme tw-cursor-pointer ${showMore ? "" : ""}`}
              onClick={onClickshowMoreProducts}
            >
              {showMore ? "Hide" : "Read more>>"}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TruncateTest;
